const defaultSettings = require("@/settings.js");

const getDefaultState = () => {
  return {
    wireless: defaultSettings.wireless,
    armor: defaultSettings.armor,
    circle: defaultSettings.circle,
    autoTimezone: defaultSettings.autoTimezone,
    insight: defaultSettings.insight,
    businessVpn: defaultSettings.businessVpn,
    advWizard: defaultSettings.advWizard,
    multiGateway: defaultSettings.multiGateway,
    ntpPageSeq: defaultSettings.ntpPageSeq,
    footerHasTncPolicy: defaultSettings.footer.hasTncPolicy,
  };
};
const state = getDefaultState();

const mutations = {};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
